import moment from 'moment';
const host = window.location.hostname;


// let BASE_API = 'http://localhost:8080/api';
// let BASE_URL = 'http://localhost:8080/api/v1/files';

// let BASE_API = 'https://devapi.dentaljob.co.kr/api';
// let BASE_URL = 'https://devapi.dentaljob.co.kr/api/v1/files';


let BASE_API = 'https://api.dentaljob.co.kr/api';
let BASE_URL = 'https://api.dentaljob.co.kr/api/v1/files';

let DOMAIN_USER = 'https://www.dentaljob.co.kr';
let DOMAIN_ADMIN = 'https://wm.dentaljob.co.kr';

if (host === 'devw.dentaljob.co.kr') {
    BASE_API = 'https://devapi.dentaljob.co.kr/api';
    BASE_URL = 'https://devapi.dentaljob.co.kr/api/v1/files';
    DOMAIN_USER = 'https://devu.dentaljob.co.kr';
    DOMAIN_ADMIN = 'https://devw.dentaljob.co.kr';
}

export { BASE_API, BASE_URL, DOMAIN_USER, DOMAIN_ADMIN };
export const APPKEY = '8f43447149eda7373cf492201951a3cb';



export const MENU_MENUS = [
    { url: '/magab010', context: '자원봉사', internalUrl: ['/magab020', '/magab030'] },
    { url: '/magac010', context: '이벤트', internalUrl: ['/magac020', '/magac040', '/magac050'] },
    { url: '/magat010', context: '법정의무교육', internalUrl: '/magat020' },
    { url: '/magad010', context: '문서서식' },
    { url: '/magae010', context: '덴탈매거진', internalUrl: ['/magae020', '/magae030'] },
];

export const MENU_MANAGEMENT = [
    { url: '/magaa010', context: '코드관리' },
    { url: '/maaaa000', context: '관리자 계정관리' }
];

export const MENU_APPROVE = [
    { url: '/macaa010', context: '등록승인' },
    { url: '/macaa020', context: '업계추정광고' },
];

export const MENU_MEMBERS = [
    { url: '/mabaa010', context: '등록회원' },
    { url: '/mabaa020', context: '탈퇴회원' },
];

export const MENU_BANNERS = [{ url: '/maeaa010', context: '광고관리', internalUrl: '/maeaa020' }];

export const MENU_CV = [{ url: '/madaa010', context: '인재정보', internalUrl: '/madaa020' }];

export const MENU_ADVERTISES = [
    {
        context: '배너상품',
        title: true,
        subMenu: [
            { url: '/mafaa030', context: '비즈니스 배너' },
            { url: '/mafaa040', context: '그랜드 배너' },
            { url: '/mafaa050', context: '프리미엄 배너' },
            { url: '/mafaa060', context: '핫리쿠르트 배너' },
            { url: '/mafaa070', context: '일반기업 배너' },
        ],
    },
    {
        context: '옵션상품',
        title: true,
        subMenu: [{ url: '/mafaa080', context: '고정 옵션' }],
    },
];

export const MENU_CENTER = [
    { url: '/magah010', context: '이메일 문의', internalUrl: '/magah020' },
    { url: '/magag010', context: '자주 묻는 질문', internalUrl: ['/magag020', '/magag030'] },
    { url: '/magaf010', context: '공지/소식', internalUrl: ['/magaf020', '/magaf030'] },
];

export const MENU_PAYMENT = [
    { url: '/maiaa010', context: '이용권 관리' },
    { url: '/maiab010', context: 'DV mall 사은품\n교환목록' },
    { url: '/maiac010', context: '결제 취소 목록' },
];

export const MENU_STATISTICAL = [
    { url: '/majaa000', context: '일보고' },
    { url: '/majaa010', context: '매출내역관리' },
    { url: '/majab010', context: '일별등록' },
    { url: '/majac010', context: '전체등록' },
    { url: '/majad010', context: '이용권등록' },
    { url: '/majad020', context: '무통장입금' },
    { url: '/majad030', context: '기타집계현황' },
    { url: '/majad040', context: '강조상품집계현황' },
    { url: 'https://iniweb.inicis.com/security/login.do', context: '이니시스상점관리', navigator: true },
];

export const MENU_ADMIN = [{ url: '/maaaa000', context: '', internalUrl: '/maaaa001' }];

export const MESSAGE = {
    confirm: {
        create: '등록하시겠습니까?',
        update: '저장하시겠습니까?',
        delete: '삭제하시겠습니까?',
    },
    code: {
        200: 'Success',
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error',
    },
    notify: {
        createSuccess: '등록 완료되었습니다.',
        createError: '오류가 발생했습니다.',
        updateSuccess: '업데이트 완료되었습니다.',
        updateError: '오류가 발생했습니다.',
        deleteSuccess: '삭제 완료되었습니다.',
        deleteError: '오류가 발생했습니다.',
        requireError: '* 사항은 필수입력 정보입니다',
    },
};

export const contactMethodMap = {
    tel: '일반전화',
    mob: '휴대폰',
    eml: '이메일',
    pps: '덴탈잡 쪽지',
};

export const getStatusText = (flag, recruitEnd, startDate, endDate, isEnd) => {
    const currentDate = moment().format('YYYY-MM-DD');

    if (isEnd === 'Y') {
        return '마감'; // #a0a0a0
    }

    switch (flag) {
        case 'K':
            return '보관'; // #698c81

        case 'O':
            if (recruitEnd < currentDate) {
                return '기간마감(시스템)'; // #a0a0a0
            }
            if (
                moment(startDate).isSameOrBefore(currentDate) &&
                moment(endDate).isSameOrAfter(currentDate)
            ) {
                return '게재중'; // #ff6600
            }
            if (moment(startDate).isAfter(currentDate)) {
                return '등록대기'; // #336633
            }
            if (moment(endDate).isBefore(currentDate)) {
                return '기간마감(시스템)'; // #a0a0a0
            }
            return '';

        case 'C':
            return '채용마감(회원)'; // #a0a0a0

        case 'E':
            return '기간마감(시스템)'; // #698c81

        case 'D':
            return '삭제'; // #6b738c

        case 'P':
            return '입금대기'; // #2178aa

        case 'V':
            return '승인대기'; // #c79b01

        case 'W':
            return '등록대기'; // #336633

        case 'X':
            return '미결제삭제'; // #6b738c

        case 'J':
            return '승인거절'; // #6b738c

        default:
            return '';
    }

};

export const selectStatusColor = (key, recruitEnd, startDate, endDate, isEnd) => {
    const currentDate = moment().format('YYYY-MM-DD');
    recruitEnd = moment(recruitEnd).format('YYYY-MM-DD');
    switch (key) {
        case 'K':
            return '#698c81';
        case 'O':
            if (recruitEnd < currentDate || isEnd === 'Y') {
                return '#a0a0a0';
            } else if (recruitEnd >= currentDate) {
                if (moment(startDate).isSameOrBefore(currentDate) && moment(endDate).isSameOrAfter(currentDate)) {
                    return '#ff6600';
                } else if (moment(startDate).isAfter(currentDate)) {
                    return '#336633';
                } else if (moment(endDate).isBefore(currentDate)) {
                    return '#a0a0a0';
                }
            }
            return '';
        case 'C':
            return '#a0a0a0';
        case 'E':
            return '#698c81';
        case 'D':
            return '#6b738c';
        case 'P':
            return '#2178aa';
        case 'V':
            return '#c79b01';
        case 'W':
            return '#336633';
        case 'X':
            return '#6b738c';
        case 'J':
            return '#6b738c';
        default:
            return '#000000'; // Default color
    }
};
